nc_initQuicklinks('ul.quicklinks')